(function() {
    'use strict';
    var PersonalDetailsBaseCtrl = function (autoInit) {
        return function ($scope, $stateParams, $modal, $filter, MyChartService, ListService, toaster, gettext, $log, PatientPortalStorageRepository) {
            $scope.loading = false;
            $scope.edit = false;
            $scope.plusPhone = false;
            $scope.hasPhoneNumber = false;
            $scope.hasEmailAddress = false;
            $scope.updateDemographicsRequestDto = null;
            $scope.phoneRegEx = /\(?\d{3}(-|\))?\s?\d{3}-?\d{4}$/;
            $scope.ssnRegEx = /^\d{3}-?\d{2}-?\d{4}$/;

            var activePatient = PatientPortalStorageRepository.getActivePatient();
            var loginUser = PatientPortalStorageRepository.getLoginUser(),
                reportRequestDto = {
                    PatientId: activePatient.id,
                    LoginUserId: loginUser.id,
                    LoginUserName: loginUser.name
                };

            var genderList = ListService.getList('genders', $scope, 'genderTypes'),
                languageList = ListService.getList('languagelist', $scope, 'languageTypes'),
                raceList = ListService.getList('racelist', $scope, 'raceTypes'),
                maritalStatusList = ListService.getList('maritalstatuslist', $scope, 'maritalStatusTypes'),
                phoneTypeList = ListService.getList('phonetype', $scope, 'phoneTypes');
            ListService.getList('ethnicitylist', $scope, 'ethnicityTypes');

            function cancelEdit() {
                $scope.updateDetailsRequestDto = null;
                $scope.edit = !$scope.edit;
                $scope.plusPhone = false;
                $scope.editPatientDetailsForm.$setPristine();
            }

            function phoneNumberFormat(input) {
                return $filter('tel')(input);
            }

            function addNumbers(){
                $scope.plusPhone = !$scope.plusPhone;
            }

            function editDetails() {
                $scope.edit = !$scope.edit;

                var dto = $scope.updateDetailsRequestDto = _.cloneDeep($scope.patientDetail);

                genderList.then(function (data) {
                    dto.Gender = _.find(data, {Id: dto.Gender && dto.Gender.Id});
                });
                languageList.then(function (data) {
                    dto.Language = _.find(data, {Id: dto.Language && dto.Language.Id});
                });
                raceList.then(function (data) {
                    dto.Race = _.find(data, {Id: dto.Race && dto.Race.Id});
                });
                maritalStatusList.then(function (data) {
                    dto.MaritalStatus = _.find(data, {Id: dto.MaritalStatus && dto.MaritalStatus.Id});
                });
                phoneTypeList.then(function (data) {
                    dto.PhoneNumber1Type = _.find(data, {Id: dto.PhoneNumber1Type && dto.PhoneNumber1Type.Id});
                    dto.PhoneNumber2Type = _.find(data, {Id: dto.PhoneNumber2Type && dto.PhoneNumber2Type.Id});
                    dto.PhoneNumber3Type = _.find(data, {Id: dto.PhoneNumber3Type && dto.PhoneNumber3Type.Id});
                    dto.PhoneNumber4Type = _.find(data, {Id: dto.PhoneNumber4Type && dto.PhoneNumber4Type.Id});
                });
            }

            function saveUpdateDetailsRequest(theForm) {
                if ((theForm || $scope.editPatientDetailsForm).$valid) {
                    $scope.saving = true;
                    $scope.updateDetailsRequestDto.PhoneNumber1 = phoneNumberFormat($scope.updateDetailsRequestDto.PhoneNumber1);
                    $scope.updateDetailsRequestDto.PhoneNumber2 = phoneNumberFormat($scope.updateDetailsRequestDto.PhoneNumber2);
                    $scope.updateDetailsRequestDto.PhoneNumber3 = phoneNumberFormat($scope.updateDetailsRequestDto.PhoneNumber3);
                    $scope.updateDetailsRequestDto.PhoneNumber4 = phoneNumberFormat($scope.updateDetailsRequestDto.PhoneNumber4);

                    MyChartService.updateDetails(activePatient.id, $scope.updateDetailsRequestDto)
                        .then(function (data) {
                            updateScope(data.plain());
                            $scope.edit = !$scope.edit;
                            (theForm || $scope.editPatientDetailsForm).$setPristine();
                            toaster.pop('success', '', gettext('Update request sent successfully.'));
                        })
                        .catch(function (response) {
                            $log.error(response);
                            toaster.pop('error', '', gettext('An error has occurred. Update request was not saved.'));
                        })
                        .finally(function () {
                            $scope.saving = false;
                        });
                }
                else {
                    toaster.pop('warning', '', gettext('Patient is not valid and cannot be saved. Please correct all issues before saving the request.'));
                }

                $scope.editPatientDetailsForm.$setPristine();
            }

            function updateScope(data) {
                $scope.patientDetail = data;
                if (data.PhoneNumber1 || data.PhoneNumber2 ||
                    data.PhoneNumber3 || data.PhoneNumber4) {
                    $scope.hasPhoneNumber = true;
                }
                if (data.EmailAddress1 || data.EmailAddress2) {
                    $scope.hasEmailAddress = true;
                }
            }

            function removePharmacy(index) {
                $scope.updateDetailsRequestDto.Pharmacies.splice(index, 1);
                $scope.editPatientDetailsForm.$setDirty();
            }

            function open() {

                var modalInstance = $modal.open({
                    templateUrl: '/mychart/views/modals/pharmacySearch.html',
                    controller: 'PharmacyModalCtrl',
                    size: 'lg',
                    resolve: {
                        pharmacies: function () {
                            return $scope.updateDetailsRequestDto.Pharmacies;
                        }
                    }
                });

                modalInstance.result.then(function (pharmacies) {
                    $scope.updateDetailsRequestDto.Pharmacies = pharmacies;
                    $scope.editPatientDetailsForm.$setDirty();
                });
            }

            function auditDemographics(reportRequestDto) {
                MyChartService.auditDemographicsLogging(reportRequestDto);
            }

            function initialize() {
                $scope.loading = true;
                $scope.removeHttpError();
                MyChartService.getPatientDetailsMetadata($scope);
                MyChartService.loadMyChart(activePatient.id)
                    .then(function (data) {
                        updateScope(data[0]);
                        $scope.config = data[1];
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
                auditDemographics(reportRequestDto);
            }
            
            $scope.tileState = {
                isCollapsed: undefined                
            };
            $scope.toggleState = function() {
                if($scope.tileState.isCollapsed === undefined)
                {
                    initialize();
                    $scope.tileState.isCollapsed = false;
                }
                else
                    $scope.tileState.isCollapsed = !$scope.tileState.isCollapsed;
            };

            $scope.addNumbers = addNumbers;
            $scope.auditDemographics = auditDemographics;
            $scope.cancelEdit = cancelEdit;
            $scope.editDetails = editDetails;
            $scope.open = open;
            $scope.removePharmacy = removePharmacy;
            $scope.saveUpdateDetailsRequest = saveUpdateDetailsRequest;

            if(autoInit) {
                initialize();
            }
        };
    };

    var PersonalDetailsCtrl = new PersonalDetailsBaseCtrl(true);
    var PersonalDetailsMobileCtrl = new PersonalDetailsBaseCtrl(false);
    
    angular.module('mychart').controller('PersonalDetailsCtrl',
        ['$scope', '$stateParams', '$uibModal', '$filter', 'MyChartService', 'ListService', 'toaster', 'aprgettext', '$log', 'PatientPortalStorageRepository',
            PersonalDetailsCtrl]);
    angular.module('mychart').controller('PersonalDetailsMobileCtrl',
        ['$scope', '$stateParams', '$uibModal', '$filter', 'MyChartService', 'ListService', 'toaster', 'aprgettext', '$log', 'PatientPortalStorageRepository',
            PersonalDetailsMobileCtrl]);
})();


